// this is needed to identify out internal pages such as review form and result page. because for these we need to apply custom override styles to hide the netchex new nav sidebar by overlapping it
import { DEER_PREFIX } from 'Deer/constants/routes';
import { matchPath, useLocation } from 'react-router-dom';

import { routes as rabbitRoutes } from 'constants/routes';

const PAGES = [
  `${DEER_PREFIX}${rabbitRoutes.performanceReview.forms}`,
  `${DEER_PREFIX}${rabbitRoutes.performanceReview.result}`,
];

export const useIsNetchexNewSidebarInternalPage = () => {
  const location = useLocation();

  const matchedRoute = PAGES.find((route) => matchPath(location.pathname, { path: route, exact: false }));

  return matchedRoute;
};
